import { render } from "./TranslateSkill.vue?vue&type=template&id=345294ca"
import script from "./TranslateSkill.vue?vue&type=script&lang=js"
export * from "./TranslateSkill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__